import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './Common/ErrorBoundary/ErrorBoundary';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found');
}
const Root = ReactDOM.createRoot(rootElement);

Root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
